import { ModalType } from '~/components/Modal/interface';

const MODAL_HISTORY_KEY = 'modal_history';

interface ModalHistoryEntry {
  name: ModalType;
  params: string;
}

class ModalsService {
  private getHistory(): ModalHistoryEntry[] {
    try {
      const history = localStorage.getItem(MODAL_HISTORY_KEY);
      return history ? JSON.parse(history) : [];
    } catch {
      return [];
    }
  }

  private saveHistory(history: ModalHistoryEntry[]) {
    localStorage.setItem(MODAL_HISTORY_KEY, JSON.stringify(history));
  }

  pushToHistory(name: ModalType, params: URLSearchParams) {
    const history = this.getHistory();

    history.push({
      name,
      params: params.toString(),
    });

    this.saveHistory(history);
  }

  popFromHistory(): ModalHistoryEntry | null {
    const history = this.getHistory();
    if (history.length > 0) {
      let timeout: ReturnType<typeof setTimeout> | null = null;
      const lastEntry = history[history.length - 1];
      history.pop();

      timeout = setTimeout(() => {
        this.saveHistory(history);
        timeout && clearTimeout(timeout);
      }, 100);

      return lastEntry || null;
    }
    return null;
  }

  getPreviousModal(): ModalHistoryEntry | null {
    const history = this.getHistory();
    const previousModal = history[history.length - 2];
    return previousModal || null;
  }

  clearHistory() {
    localStorage.removeItem(MODAL_HISTORY_KEY);
  }

  get hasHistory(): boolean {
    return this.getHistory().length > 0;
  }

  get currentModal(): ModalHistoryEntry | null {
    const history = this.getHistory();
    return history[history.length - 1] || null;
  }
}

export const modalsService = new ModalsService();
